import React, { useContext } from 'react';
import styled from 'styled-components';
import { EditorContext } from '@/features/editor/context/editor-context';
import { DeviceType } from '@/utils/definitions';
import { breakpoints } from '@/components/responsive';

export const INSPECTOR_WRAPPER_ID = `inspector-wrapper`;
export const INSPECTOR_CONTROLS_ID = `inspector-controls`;
export const INSPECTOR_BACK_ID = `inspector-back`;

export function Inspector({
  alignPreviewRight = false,
}: {
  alignPreviewRight?: boolean;
}) {
  const { devicePreview, inspectorNav, inspectorRef, resetWidget } =
    useContext(EditorContext);
  const { device } = devicePreview.editorState;
  const { getCurrentWidget } = inspectorNav;

  return (
    <Wrapper
      className={device}
      key={`widget-${resetWidget}`}
      id={INSPECTOR_WRAPPER_ID}
      device={device}
      alignPreviewRight={alignPreviewRight}
      ref={inspectorRef}
    >
      {getCurrentWidget()}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  max-width: ${(props: InspectorWrapperProps) =>
    props.device === DeviceType.Desktop ? `100%` : `100rem`};
  overflow-x: hidden;
  overflow-y: hidden;
  padding: ${(props: InspectorWrapperProps) =>
    getInspectorPadding(props, `default`)};
  ${breakpoints.down(1600)} {
    padding: ${(props: InspectorWrapperProps) =>
      getInspectorPadding(props, `1600`)};
  }
  ${breakpoints.down(1400)} {
    padding: ${(props: InspectorWrapperProps) =>
      getInspectorPadding(props, `1400`)};
  }
`;

interface InspectorWrapperProps {
  device: DeviceType;
  alignPreviewRight: boolean;
}

type InspectorPaddingBreakpoint = `default` | `1600` | `1400`;

function getInspectorPadding(
  { device, alignPreviewRight }: InspectorWrapperProps,
  breakpoint: InspectorPaddingBreakpoint,
) {
  if (device !== DeviceType.Desktop) {
    return alignPreviewRight ? `0 0 0 13rem` : `0 6.5rem`;
  }

  if (breakpoint === `1400`) {
    return alignPreviewRight ? `0 0 0 2rem` : `0 0 0 1.2rem`;
  }

  if (breakpoint === `1600`) {
    return alignPreviewRight ? `0 0 0 5.5rem` : `0 3.5rem`;
  }

  return alignPreviewRight ? `0 0 0 7rem` : `0 3.5rem`;
}
